import {RenderTemplateCallback} from "../../../src/types";
import {colors, TemplateKeys} from "./shared";

export const renderChristmasTemplate: RenderTemplateCallback = async (ctx, utils, template, data, signatures) => {
    const templateKey = template.key as TemplateKeys;
    const scale = utils.templateScaler(template);
    const font = utils.fontScaler(template);
    const image = utils.imageScaler(template);

    const width = scale(1, '%w');
    const height = scale(1, '%h');

    ctx.clearRect(0, 0, width, height);

    const textLeftMargin = scale(40);
    const headlineWidth = width - (textLeftMargin * 2);

    // Render card background image
    image(ctx, {
        image: await utils.getImage(require(`../assets/CWS_Weihnachtskarte_${templateKey}.png`).default),
        left: 0,
        top: 0,
        scale: 1
    });

    // Render main text
    const content = utils.getText(data.content).trim();
    const contentTop = 478;
    const contentWidth = 520;
    const { height: contentHeight } = utils.renderText(ctx, {
        font: font(20, 'Suisse-Regular'),
        text: content,
        fillStyle: colors[templateKey].text,
        x: textLeftMargin,
        y: scale(contentTop),
        lineHeight: scale(20),
        fromTop: true,
        maxWidth: scale(contentWidth)
    });

    // Render signatures
    let left = textLeftMargin;
    let top = contentTop + Math.max(scale(25), contentHeight+scale(25));
    const bottomSignatureBoundary = scale(825);
    for(const signature of signatures) {
        // Calculate width of signature and subtitle to see if signature should break to new line
        ctx.save();
        const signatureFont = font(20, 'AlFresco');
        ctx.font = signatureFont;
        const sigM = ctx.measureText(signature.signature);
        ctx.restore();

        ctx.save();
        const subtitleFont = font(8, 'Suisse-Regular');
        ctx.font = subtitleFont;
        const subM = ctx.measureText(signature.subtitle);
        ctx.restore();

        let willBreak = false;
        if (
            left + sigM.width + scale(textLeftMargin) > contentWidth + textLeftMargin ||
            left + subM.width +scale(textLeftMargin) > contentWidth + textLeftMargin
        ) {
            willBreak = true;
        }

        // Render signature
        const measure = utils.renderSignature(ctx, {
            signature: {
                font: signatureFont,
                text: signature.signature,
                fillStyle: colors[templateKey].text
            },
            subtitle: {
                font: subtitleFont,
                text: signature.subtitle,
                fillStyle: colors[templateKey].text,
                offset: scale(15)
            },
            x: willBreak ? textLeftMargin : left,
            y: top + (willBreak? scale(70) : 0),
            bottomBoundary: bottomSignatureBoundary
        });

        // Calculate position for next signature
        left += measure.width + scale(20);
        if (left+scale(50) > contentWidth) {
            top += scale(70);
            left = textLeftMargin + (willBreak ? measure.width + scale(20) : 0);
        }
    }
}